import { createFileRoute } from '@tanstack/react-router'

import { Page } from '@/components/page'
import { ImportExportScreen } from '@/features/exchange/ImportExportScreen'

export interface ImportExportSearch {
  /** The parts-list query string to hand to the export, URL-encoded. */
  parts?: string
}

export const Route = createFileRoute('/import-export')({
  component: ImportExportPage,
  validateSearch: (search: Record<string, unknown>): ImportExportSearch => ({
    parts: typeof search.parts === 'string' && search.parts ? search.parts : undefined,
  }),
})

function ImportExportPage() {
  const { parts } = Route.useSearch()

  return (
    <Page title="Exchange" description="Move data in and out as CSV, and keep exchange rates.">
      <ImportExportScreen partsQuery={parts} />
    </Page>
  )
}
